import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class WindowReferenceService {
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  get nativeWindow() {
    return this.getWindow();
  }

  getWindow():any {
    if(this.isBrowser) {
      return window;
    }
    return null;
  }
}
